import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalFontSize } from '../context/GlobalFontSizeContext';

const LINK_CLASS =
  'underline underline-offset-2 hover:text-bloom-green transition-colors';

const Privacy = () => {
  const { t } = useTranslation();
  const { fontSize } = useGlobalFontSize();

  return (
    <div className="w-full h-full overflow-y-auto bg-dark-app">
      <div className="w-full pt-[24px] pb-[32px] px-[16px] md:px-[32px]">
        <div className="flex flex-col gap-[2px] min-w-0">
          <h1
            className="font-['Inter'] font-semibold text-[18px] leading-[27px] text-[#282A29] dark:text-[#f0f5f2]"
            style={{ fontSize: fontSize + 4 }}
          >
            {t('privacy.title')}
          </h1>
          <p
            className="font-['Inter'] font-normal text-[14px] leading-[21px] text-[#5D625F] dark:text-[#828382]"
            style={{ fontSize }}
          >
            {t('privacy.subtitle')}
          </p>
        </div>

        <div className="mt-[24px] mb-[32px] h-[1px] bg-[#E2E2E2] dark:bg-[#282a29]" />

        <p
          className="font-['Inter'] font-normal text-[14px] leading-[21px] text-[#282A29] dark:text-[#f0f5f2]"
          style={{ fontSize }}
        >
          {t('privacy.description')}{' '}
          <a
            href="https://bloomiq.io/legal"
            target="_blank"
            rel="noopener noreferrer"
            className={LINK_CLASS}
          >
            {t('privacy.privacyCenter')}
          </a>{' '}
          {t('privacy.and')}{' '}
          <a
            href="https://bloomiq.io/legal/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className={LINK_CLASS}
          >
            {t('privacy.privacyPolicy')}
          </a>{' '}
          {t('privacy.moreDetails')}
        </p>
      </div>
    </div>
  );
};

export default Privacy;
